<template>
  <div>
    <b-modal
      id="contact-modal"
      ref="contact-modal-ref"
      hide-footer
      :title="'Contact Us'"
    >
      <div v-if="bookingData" class="vtd-modal-content">
        <div class="vtd-modal-body">
          <div class="vtd-row vtd-m-0">
            <div class="col-12 col-md-12 modal-alert">
              <h3 class="vtd-text-uppercase vtd-m-0">
                BOOKING REFERENCE: {{ bookingData.user_information.bookingNumber }}
              </h3>
            </div>
          </div>
        </div>
        <div v-if="isHome">
          <p>As you have now returned from your trip, should you need to contact us please call on one of the numbers below.</p>
          <div
            v-for="(item, index) in bookingData.consultant_information
              .branchContact"
            :key="index"
            class="consultant-contact text-center"
          >
            <span class="tc-title"> {{ item["line" + index].branch }}: </span>
            <span class="tc-number"><a :href="'tel:' + item['line' + index].telno.replace(/ /g,'')">{{ item["line" + index].telno }}</a></span>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>
  
  <script>
  import { mapGetters } from "vuex";
  import { isHomeCheck } from "@/partials/contact-us/contact-us.module.js";
  export default {
    data() {
      return {
        isHome: false,  
    }
    },
    computed: {
      ...mapGetters({
        bookingData: 'booking/getBooking',
        area: "faq/getCurrentArea",
      }),
    },
    async mounted() {
      if (this.bookingData && this.bookingData.user_information) {
        if (isHomeCheck(this.bookingData)) {
            this.isHome = true;
        }
      }
    },
    methods:{
      show: function() {
        this.$refs["contact-modal-ref"].show();
      },
      closeModal() {
        this.$refs["contact-modal-ref"].hide();
      },
      openModal(item) {
        this.$refs["contact-modal-ref"].hide()
        this.$refs[item].showModal()
      },
    }
  };
  </script>
  
  <!-- <style>
  @import "./styles.scss";
  </style> -->
  